import { render, staticRenderFns } from "./ProRetouchersInfoBlock.vue?vue&type=template&id=05d86a90&"
import script from "./ProRetouchersInfoBlock.vue?vue&type=script&lang=js&"
export * from "./ProRetouchersInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports